// extracted by mini-css-extract-plugin
export var quantityInput = "_fg-0";